import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Select, Input, Button } from "antd";
import useDebounce from "../../Common/hooks/useDebounce";
import ExamCard from "../../Exams/ExamCard.component";
import { instance } from "../../../constants/constString";

const { Option } = Select;
const sharedInputStyles = {
  padding: "7px 11px",
  fontSize: "16px",
  borderColor: "gray",
  borderRadius: "10px",
  boxSizing: "border-box", // Ensures padding is included in the total width/height
  lineHeight: "1.5715", // Match the line-height too for vertical centering
};

const PracticeExamTab = (props) => {
  const { practiceExam, allSubjects, selectedSubjectPractice, courseId } =
    props;
  const inputRef = useRef();
  const [examList, setExamList] = useState(practiceExam);
  const [searchText, setSearchText] = useState("");
  const [thePrompt, setThePrompt] = useState(""); // this will show up in search box
  const debouncedSearchTerm = useDebounce(searchText, 500); // 500ms delay

  const fetchPrompt = async () => {
    try {
      const response = await instance.get("/exam/getExamNamePrompt", {
        params: {
          search: searchText,
          courseId: courseId,
          isPracticeExam: true,
          subjectId: selectedSubjectPractice,
        },
      });
      setThePrompt(response?.data?.data ?? "");
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm?.length > 1) fetchPrompt();
    // eslint-disable-next-line
  }, [courseId, selectedSubjectPractice, debouncedSearchTerm]);

  const handlePromptClear = () => {
    setThePrompt("");
    setExamList(practiceExam);
  };

  const handleSearch = (val) => {
    setSearchText(val ?? "");
    if (!val || val?.length < 1) {
      handlePromptClear();
    }
  };

  const handleSearchSubmit = () => {
    const modifiedExams = practiceExam?.filter((item) =>
      item?.examId?.title?.toLowerCase().includes(searchText?.toLowerCase() ?? "")
    );
    setExamList(modifiedExams);
  };
  useEffect(
      handleSearchSubmit,
      // eslint-disable-next-line
      [debouncedSearchTerm]
    );

  return (
    <React.Fragment>
      <Row
        className="selectLiveExamType"
        style={{ marginRight: 0, marginLeft: 0 }}
      >
        <Col className="exam-filter-nav" xs={24} md={24}>
          <div
            className="selectSubject-select"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Select
              onChange={props.setSelectedSubjectPractice}
              placeholder="All Subjects"
              allowClear
            >
              {allSubjects.map((item, index) => {
                if (
                  practiceExam
                    .map((exam) => exam?.examId?.subjectId)
                    .includes(item?._id) === false
                ) {
                  return null;
                }
                return (
                  <Option key={index} value={item?._id}>
                    {item?.name}
                  </Option>
                );
              })}
            </Select>
          </div>
        </Col>
      </Row>
      {examList?.length < 1 && !searchText ? (
        <></>
      ) : (
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "right",
            padding: "12px",
            alignItems: "center",
          }}
        >
          <div style={{ position: "relative", display: "inline-block" }}>
            <Input
              ref={inputRef}
              value={searchText}
              size="large"
              style={{
                ...sharedInputStyles, // Apply the shared styles
                width: "100%",
                position: "relative",
                background: "transparent", // Keep input background transparent to see the ghost text
                color: "black", // This is the color of the text you type
                zIndex: 2, // Ensure the input text and cursor are on top
              }}
              className="transparent-input"
              placeholder="Search"
              onKeyDown={(e) => {
                if (e.key === "Tab" && thePrompt) {
                  e.preventDefault(); // stop default tabbing away
                  setSearchText(thePrompt); // fill input with prompt
                }
              }}
              onChange={(e) => handleSearch(e.target.value)}
              suffix={
                <span
                  style={{
                    border: "1px solid gray",
                    padding: "0 8px",
                    cursor: "pointer",
                    borderRadius: 90,
                  }}
                  onClick={() => {
                    handleSearch("");
                    handlePromptClear();
                  }}
                >
                  x
                </span>
              }
            />

            {/* Inline ghost text */}
            {thePrompt && searchText && (
              <div
                style={{
                  ...sharedInputStyles, // Apply the exact same shared styles
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  color: "transparent", // This part hides the text that the user already typed
                  pointerEvents: "none", // Allows clicks to pass through to the input below
                  display: "flex",
                  alignItems: "center",
                  zIndex: 1, // Place it behind the input's text
                }}
              >
                <span style={{ paddingLeft: "12px" }}>{searchText}</span>
                <span style={{ color: "rgba(0, 0, 0, 0.35)" }}>
                  {thePrompt.slice(searchText.length)}
                </span>
              </div>
            )}
          </div>

          <Button
            size="large"
            type="primary"
            style={{ borderRadius: 10 }}
            onClick={handleSearchSubmit}
          >
            Search
          </Button>
        </div>
      )}

      <Row
        gutter={[16, 16]}
        style={{ marginRight: 0, marginLeft: 0, paddingBottom: 50 }}
      >
        {examList.map((exam, index) => {
          if (
            selectedSubjectPractice &&
            selectedSubjectPractice !== exam?.examId?.subjectId
          ) {
            return null;
          }
          return (
            <Col key={index} xs={24} sm={12} md={6} lg={6}>
              <ExamCard exam={exam} allSubjects={allSubjects} />
            </Col>
          );
        })}
      </Row>
    </React.Fragment>
  );
};

export default PracticeExamTab;
